module.exports = __webpack_public_path__ + "img/Image_12.24ed5bdd.png";